import React from "react";
import Directions from "../../home/directions/Directions";

const MagistraturaDirections = () => {
  return <Directions titleOverride={"Magistratura yo'nalishlari"} endpoint={"/api/directions/masters/"} filterLevel={"master"} />;
};

export default MagistraturaDirections; 